import Label from "../../../../components/title/label";
import Input from "../../../../components/input/Input";
import Checkbox from "../../../../components/button/Checkbox";
import { Link } from "react-router-dom";
import { RiArrowGoBackFill } from "react-icons/ri";
import BackButton from "../../../../components/button/BackButton";
import { Navbar } from "../../../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { E_immatriculation } from "../../../../constants/constant";


function ActiviteContgribuable() {   
   
  

     const [activite, setActivite] = useState(null);
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
    
      const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
      const contribuableData = JSON.parse(selectedData);
    
      useEffect(() => {
        const fetchActivite = async () => {
          setLoading(true);
          try {
            const response = await axios.get(`${E_immatriculation}/activite/contribuable/${contribuableData.id}`);
            setActivite(response.data[0]);
            setError(null);
          } catch (err) {
            setError("Erreur lors du chargement des données");
            console.error(err);
          } finally {
            setLoading(false);
          }
        };
    
        fetchActivite();
      }, [contribuableData.id]);
    
    
    
    
      if (loading) return <div>Chargement...</div>;
      if (error) return <div className="text-red-500">{error}</div>;
      if (!activite) return <div>Aucune donnée disponible</div>;
    
    // Navbar content
  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className="text-white">
      Activité
     </div>
      <BackButton to="/SituationGeographiqueIm"></BackButton>
    </nav>
  );
    return (
       <div className="w-full bg-[#212122]">
            <Navbar content={contentNavbar} />
            <main className=""><div >

  
          <div className="flex justify-center">
            <div className="flex flex-col  w-[800px] p-4 rounded-lg shadow-md">
              <div className="flex justify-between mt-6">
                <Label text="Activités" />
                <Input
                  type="text"
                  value={activite.activite}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Précision sur les activités" />
                <Input
                  type="text"
                  value={activite.precision_activite}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Numéro d'identification Fiscal" />
                <Input
                  type="text"
                  value={activite.nif}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Numéro statistique" />
                <div className="flex flex-col">
                  <div className="flex justify-between w-[300px]">
                    <Checkbox
                      label="Disponible"
                      checked={activite.statistique}

                    />
                    <Checkbox
                      label="Pas encore Disponible"
                      checked={!activite.statistique}

                    />
                  </div>
                  {activite.statistique && (
                    <Input
                      type="text"
                      value={activite.numero_statistique}

                      className="mt-2"
                    />
                  )}
                </div>
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Date de délivrance statistique" />
                <Input
                  type="date"
                  value={activite.date_delivrance_statistique}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Registre de commerce" />
                <Input
                  type="text"
                  value={activite.registre_commerce}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Date de registre de commerce" />
                <Input
                  type="date"
                  value={activite.date_registre_commerce}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Début de l'exercice comptable" />
                <Input
                  type="date"
                  value={activite.debut_exercice}
                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Clôture de l'exercice comptable" />
                <Input
                  type="date"
                  value={activite.cloture_exercice}

                />
              </div>
  
              <div className="flex justify-between mt-6">
                <Label text="Nombre salarié" />
                <Input
                  type="text"
                  value={activite.nombre_salarie}
                />
              </div>
  
              <div className="flex justify-between mt-6">
            
                <Link
                  to="/SituationGeographiqueIm"
                  className="border-[2px] p-2 border-white text-white rounded hover:bg-black/70 hover:text-white flex flex-row items-center"
                >
                  <RiArrowGoBackFill className="text-2xl text-white mr-2" />
                  Fermer
                </Link>
              </div>
            </div>
          </div>
        </div></main>
          </div>
        
      
    );
  }

export default ActiviteContgribuable